angular.module('impactx.approval').service('ApprovalOverviewService', [
    '$mdDialog',
    ApprovalOverviewService
]);

function ApprovalOverviewService($mdDialog) {

    function openApprovalOverviewDialog($event, prhId, dehId) {
        return $mdDialog.show({
            controller: 'ApprovalOverviewDialogCtrl',
            controllerAs: '$ctrl',
            templateUrl: 'shared/approval/templates/approval-overview.dialog.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                prhId: prhId,
                dehId: dehId
            }
        });
    }

    return {
        openDialog: openApprovalOverviewDialog
    };
}